module.exports = __webpack_public_path__ + "static/media/6.11817571.gif";